import { PeriodContext } from '@/contexts/Period';
import moment from 'moment';
import React from 'react';

export function PeriodProvider({ children }: React.PropsWithChildren) {

  let hoje = moment(Date.now()).format('DD-MM-YYYY');
  let ontem = moment().subtract(1, 'days').format('DD-MM-YYYY');

  const [period, setPeriod] = React.useState<[string, string]>([
    ontem,
    hoje,
  ]);

  const context = {
    period,
    setPeriod,
  };

  return (
    <PeriodContext.Provider value={context}>
      {children}
    </PeriodContext.Provider>
  );
}
